import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { BasketCardFooterContainer, Separator, ContentContainer, LinkAndIconContainer, BookingData } from "./styles";

import IconButton from "components/IconButton";
import { LinkButton } from "components/Button";
import { setModal } from "state/config-slice";
import Offer from "types/Offer";
import ExternalArrow from "components/IconButton/icons/ExternalArrow";
import Trash from "components/IconButton/icons/Trash";

interface BasketCardFooterV2Props {
  removeOfferFromBasket: () => void;
  onTncClickHandle: () => void;
  offer: Offer;
}

const BasketCardFooterV2: React.FC<BasketCardFooterV2Props> = ({ offer, removeOfferFromBasket, onTncClickHandle }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    marketplaceInfo: { logoName, bookingDetails, privacy },
  } = offer || {};

  const onBookingDetailsClickHandle = () => {
    dispatch(
      setModal({
        showModal: true,
        title: bookingDetails?.title,
        children: (
          <BookingData
            dangerouslySetInnerHTML={{
              __html: bookingDetails?.details || "",
            }}
          />
        ),
        textAlign: "left",
        icon: null,
        type: "",
        size: "large",
        button: null,
        enableGradient: false,
      }),
    );
  };

  const onPrivacyPolicyClickHandle = () => {
    window.open(privacy?.description, "_blank");
  };

  return (
    <BasketCardFooterContainer data-testid="BasketCardFooterContainer">
      <Separator />
      <ContentContainer>
        <LinkAndIconContainer>
          <LinkButton
            title={t("{{ partner }} T&Cs", { partner: logoName })}
            onClick={onTncClickHandle}
            data-testid="tnc-link"
          />
          <IconButton onClick={onTncClickHandle} id="tncExternalIcon" Icon={ExternalArrow} />
        </LinkAndIconContainer>
        {privacy && (
          <LinkAndIconContainer>
            <LinkButton
              title={t("Offer privacy policy")}
              onClick={onPrivacyPolicyClickHandle}
              data-testid="privacy-policy-link"
            />
            <IconButton onClick={onPrivacyPolicyClickHandle} id="privacyExternalIcon" Icon={ExternalArrow} />
          </LinkAndIconContainer>
        )}
        {bookingDetails && (
          <LinkButton
            title={t("Booking details")}
            onClick={onBookingDetailsClickHandle}
            data-testid="booking-details-link"
          />
        )}

        <IconButton id="removeIcon" data-testid="removeOfferIcon" onClick={removeOfferFromBasket} Icon={Trash} />
      </ContentContainer>
    </BasketCardFooterContainer>
  );
};

export default BasketCardFooterV2;
